// constants.ts

export const API_BASE_URL: string = "https://api.example.com";
export const MAX_DATA_DENCITY_THRESOLD_PCT: number = 0.98;
export const NULL_DENCITY_THRESOLD_PCT: number = 0.90;

export const textFieldIconData: string = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTBweCIgaGVpZ2h0PSIxN3B4IiB2aWV3Qm94PSIwIDAgMTAgMTciIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8ZyBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOTc1LjAwMDAwMCwgLTIxOS4wMDAwMDApIiBmaWxsPSIjNERDMkNGIiBmaWxsLXJ1bGU9Im5vbnplcm8iPgogICAgICAgICAgICA8ZyAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOTcxLjAwMDAwMCwgMjE3LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHBvbHlnb24gIHBvaW50cz0iMTQgNC40NDY3NzY2MSAxMC4yNSA0LjQ0Njc3NjYxIDEwLjI1IDE5IDcuNzUgMTkgNy43NSA0LjQ0Njc3NjYxIDQgNC40NDY3NzY2MSA0IDIgMTQgMiI+PC9wb2x5Z29uPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";
export const integerFieldIconData: string = "data:image/svg+xml;base64,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";
export const dropdownFieldIconData: string = "data:image/svg+xml;base64,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";
export const decimalFieldIconData: string = "data:image/svg+xml;base64,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";
export const dateFieldIconData: string = "data:image/svg+xml;base64,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";
export const dateTimeFieldIconData: string = "data:image/svg+xml;base64,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";
export const doubleFieldIconData: string = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjBweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjAgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8ZyAgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgIHRyYW5zZm9ybT0idHJhbnNsYXRlKC05NzEuMDAwMDAwLCAtNDA3LjAwMDAwMCkiPgogICAgICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5NjkuMDAwMDAwLCA0MDcuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMS4wMDAwMDAsIDAuMDAwMDAwKSIgZmlsbD0iIzI4ODc5MSIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgICAgICAgICA8cG9seWdvbiBwb2ludHM9IjEuNiAxLjIgMC45IDEuMiAwLjkgMC4zIDIuNiAwLjMgMi42IDQuNyAxLjYgNC43Ij48L3BvbHlnb24+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTYuNSw0LjQgQzYuMiw0LjcgNS45LDQuOSA1LjMsNC45IEM0LjgsNC45IDQuNCw0LjcgNC4xLDQuNCBDMy43LDQgMy41LDMuMyAzLjUsMi41IEMzLjUsMS43IDMuNywxLjEgNC4xLDAuNiBDNC40LDAuMyA0LjcsMC4xIDUuMywwLjEgQzUuOCwwLjEgNi4yLDAuMyA2LjUsMC42IEM2LjksMSA3LjEsMS43IDcuMSwyLjUgQzcuMiwzLjMgNywzLjkgNi41LDQuNCBaIE00LjksMS4yIEM0LjYsMS41IDQuNSwyLjIgNC41LDIuNSBDNC41LDIuOCA0LjYsMy41IDQuOSwzLjggQzUuMSwzLjkgNS4yLDQgNS40LDQgQzUuNiw0IDUuNywzLjkgNS44LDMuOCBDNi4xLDMuNSA2LjIsMi45IDYuMiwyLjUgQzYuMiwyLjIgNi4yLDEuNSA1LjgsMS4yIEM1LjcsMS4xIDUuNiwxIDUuNCwxIEM1LjIsMS4xIDUuMSwxLjEgNC45LDEuMiBaIiA+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMC40LDQuNCBDMTAuMSw0LjcgOS44LDQuOSA5LjIsNC45IEM4LjcsNC45IDguMyw0LjcgOCw0LjQgQzcuNiw0IDcuNCwzLjMgNy40LDIuNSBDNy40LDEuNyA3LjYsMS4xIDgsMC42IEM4LjMsMC4zIDguNiwwLjEgOS4yLDAuMSBDOS43LDAuMSAxMC4xLDAuMyAxMC40LDAuNiBDMTAuOCwxLjEgMTEsMS44IDExLDIuNSBDMTEsMy4zIDEwLjgsMy45IDEwLjQsNC40IFogTTguOCwxLjIgQzguNSwxLjUgOC40LDIuMiA4LjQsMi41IEM4LjQsMi44IDguNSwzLjUgOC44LDMuOCBDOC45LDMuOSA5LDQgOS4yLDQgQzkuNCw0IDkuNSwzLjkgOS42LDMuOCBDOS45LDMuNSAxMCwyLjkgMTAsMi41IEMxMCwyLjIgMTAsMS41IDkuNiwxLjIgQzkuNSwxLjEgOS40LDEgOS4yLDEgQzksMS4xIDguOSwxLjEgOC44LDEuMiBaIiA+PC9wYXRoPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPGNpcmNsZSAgZmlsbD0iIzREQzJDRiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOC40ODUyMDAsIDEzLjgxMzY4MCkgcm90YXRlKC00NS4wMDAwMDApIHRyYW5zbGF0ZSgtOC40ODUyMDAsIC0xMy44MTM2ODApICIgY3g9IjguNDg1MiIgY3k9IjEzLjgxMzY4IiByPSI1Ljk5OTk0MjQ2Ij48L2NpcmNsZT4KICAgICAgICAgICAgICAgIDxnICB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5LjQ1ODMyMCwgNC4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8Y2lyY2xlICBmaWxsPSIjREREREREIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0LjIxMDk1MCwgNC4yNzc1MTApIHJvdGF0ZSgtNDUuMDAwMDAwKSB0cmFuc2xhdGUoLTQuMjEwOTUwLCAtNC4yNzc1MTApICIgY3g9IjQuMjEwOTUiIGN5PSI0LjI3NzUxIiByPSIyLjU5OTk3NTA3Ij48L2NpcmNsZT4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMy44LDQuMyBMMyw1LjEgQzIuOSw1LjEgMi44LDUuMiAyLjcsNS4yIEMyLjYsNS4yIDIuNSw1LjIgMi40LDUuMSBDMi40LDUgMi4zLDQuOSAyLjMsNC44IEMyLjMsNC43IDIuMyw0LjYgMi40LDQuNSBMMy45LDMgQzQsMyA0LjEsMi45IDQuMiwyLjkgQzQuMywyLjkgNC40LDIuOSA0LjUsMyBMNiw0LjUgQzYsNC42IDYsNC43IDYsNC44IEM2LDQuOSA2LDUgNS45LDUuMSBDNS44LDUuMiA1LjcsNS4yIDUuNiw1LjIgQzUuNSw1LjIgNS40LDUuMiA1LjMsNS4xIEw0LjUsNC4zIEw0LjEsMy45IEwzLjgsNC4zIFoiICBmaWxsPSIjM0RBNEFGIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICA8cG9seWdvbiAgZmlsbD0iI0ZGRkZGRiIgZmlsbC1ydWxlPSJub256ZXJvIiBwb2ludHM9IjcuODU4MzIgMTUgNS43NTgzMiAxMS4zIDcuNTU4MzIgMTEuMyA4LjY1ODMyIDEzLjUgOS43NTgzMiAxMS4zIDExLjU1ODMyIDExLjMgOC4xNTgzMiAxNy44IDYuNDU4MzIgMTcuOCI+PC9wb2x5Z29uPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";
export const booleanFieldIconData: string = "data:image/svg+xml;base64,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";

export const DQ_RULE_CAT_LABELS: Record<string, string> = {
  std: "Standardization",
  val: "Validation",
  cons: "Consistency",
  ref: "Reference",
  mgmt: "Governance",
  other: "Other",
};



// Recursively traverse DM structure and attach profile insight

export const attachInsightsToDM = (dm: any[], profiles: any[]): any[] => {
  const profileMap: Record<string, any> = {};
  profiles.forEach((p) => {
    profileMap[p.column_name] = p.insight || null;
  });

  function attachField(field: any): any {
    const newField: any = { ...field };

    if (field.eClass === "Field") {
      const parts = field.FLD_PHYSICAL_ID?.split("-");
      const key = parts && parts.length > 1 ? parts[1] : null;
      newField.insight = profileMap[key || ""] || field.insight || null;
    } else if (field.eClass === "FieldGroup" && field.field?.length) {
      newField.field = field.field.map((f:any) => attachField(f));
    }

    return newField;
  }

  return dm.map((entity) => {
    const newEntity: any = { ...entity };
    if (entity.eClass === "FieldGroup" && entity.field?.length) {
      newEntity.field = entity.field.map((f:any) => attachField(f));
    }
    return newEntity;
  });
}

export const attachProfileToDM = (
  dm: any[],
  profiles: any[],
  preserveProfilingOrder: boolean = false
): any[] => {
  if (!Array.isArray(dm) || !Array.isArray(profiles)) return dm;

  // ─── Build profile lookups ──────────────────────────────────────────────
  // Normalize once so case differences across systems don't break matching.
  const norm = (s: any): string =>
    typeof s === "string" ? s.trim().toUpperCase() : "";

  // Primary lookup: composite (table, column) → profile
  const profileByTableCol: Record<string, any> = {};
  // Order tracking on the same composite key
  const orderByTableCol: Record<string, number> = {};

  // Fallback lookups for legacy/edge cases:
  //   - column_name as-is (prefixed or not)
  //   - orig_column_name only (when no prefix collision is possible)
  // The fallbacks are last-write-wins, so they only help when (table,col)
  // matching has already failed — i.e. unprefixed profiles or legacy data.
  const profileByColumnName: Record<string, any> = {};
  const profileByOrigCol:    Record<string, any> = {};
  const orderByColumnName:   Record<string, number> = {};
  const orderByOrigCol:      Record<string, number> = {};

  profiles.forEach((p, idx) => {
    const tbl  = norm(p.source_prefix);
    const orig = norm(p.orig_column_name);
    const cn   = norm(p.column_name);

    if (tbl && orig) {
      const key = `${tbl}::${orig}`;
      profileByTableCol[key] = p;
      orderByTableCol[key]   = idx;
    }

    if (cn) {
      profileByColumnName[cn] = p;
      orderByColumnName[cn]   = idx;
    }

    if (orig) {
      profileByOrigCol[orig] = p;
      orderByOrigCol[orig]   = idx;
    }
  });

  // ─── Resolver: try composite key first, then fallbacks ──────────────────
  function resolveProfile(field: any): { profile: any; order: number } {
    // 1. Composite key (PRIMARY): ORIG_TABLE_NAME + ORIG_COLUMN_NAME
    const tbl  = norm(field.ORIG_TABLE_NAME);
    const orig = norm(field.ORIG_COLUMN_NAME);
    if (tbl && orig) {
      const key = `${tbl}::${orig}`;
      if (profileByTableCol[key] !== undefined) {
        return { profile: profileByTableCol[key], order: orderByTableCol[key] };
      }
    }

    // 2. Fallback: legacy FLD_PHYSICAL_ID parsing (kept for backward compat)
    //    FLD_PHYSICAL_ID format: "<TableId>-<column_name>"
    if (typeof field.FLD_PHYSICAL_ID === "string") {
      const dashIdx = field.FLD_PHYSICAL_ID.indexOf("-");
      if (dashIdx > -1) {
        const physCol = norm(field.FLD_PHYSICAL_ID.substring(dashIdx + 1));
        if (physCol && profileByColumnName[physCol] !== undefined) {
          return {
            profile: profileByColumnName[physCol],
            order:   orderByColumnName[physCol],
          };
        }
        if (physCol && profileByOrigCol[physCol] !== undefined) {
          return {
            profile: profileByOrigCol[physCol],
            order:   orderByOrigCol[physCol],
          };
        }
      }
    }

    // 3. Final fallback: ORIG_COLUMN_NAME alone (only safe when no
    //    duplicate column names exist across tables — which is exactly
    //    the case this whole rewrite is solving for, but kept as a
    //    last resort for malformed profiles missing source_prefix)
    if (orig && profileByOrigCol[orig] !== undefined) {
      return {
        profile: profileByOrigCol[orig],
        order:   orderByOrigCol[orig],
      };
    }

    return { profile: null, order: Infinity };
  }

  // ─── Recursive walk (unchanged shape) ───────────────────────────────────
  function attachField(field: any): any {
    const newField: any = { ...field };

    if (field.eClass === "Field") {
      const { profile, order } = resolveProfile(field);
      newField.profile = profile;

      if (preserveProfilingOrder) {
        newField._profileOrder = order;
      }
    } else if (field.eClass === "FieldGroup" && Array.isArray(field.field)) {
      newField.field = field.field.map((f: any) => attachField(f));

      if (preserveProfilingOrder) {
        newField.field.sort(
          (a: any, b: any) =>
            (a._profileOrder ?? Infinity) - (b._profileOrder ?? Infinity)
        );
      }
    }

    return newField;
  }

  return dm.map((entity) => {
    const newEntity: any = { ...entity };

    if (Array.isArray(entity.field)) {
      newEntity.field = entity.field.map((f: any) => attachField(f));

      if (preserveProfilingOrder) {
        newEntity.field.sort(
          (a: any, b: any) =>
            (a._profileOrder ?? Infinity) - (b._profileOrder ?? Infinity)
        );
      }
    }

    return newEntity;
  });
};

export const attachProfileToDM_old = ( //will not use anymore
  dm: any[],
  profiles: any[],
  preserveProfilingOrder: boolean = false
): any[] => {
  if (!Array.isArray(dm) || !Array.isArray(profiles)) return dm;

  // --- Build profile lookup and order map ---
  const profileMap: Record<string, any> = {};
  const columnOrderMap: Record<string, number> = {};

  profiles.forEach((p, idx) => {
    profileMap[p.column_name] = p;
    columnOrderMap[p.column_name] = idx; // preserve column order
  });

  // --- Recursive function to attach profile and optionally assign order ---
  function attachField(field: any): any {
    const newField: any = { ...field };

    if (field.eClass === "Field") {
      const parts = field.FLD_PHYSICAL_ID?.split("-");
      const key = parts && parts.length > 1 ? parts[1] : null;

      const profile = profileMap[key || ""] || null;
      newField.profile = profile;

      if (preserveProfilingOrder) {
        newField._profileOrder =
          key && columnOrderMap[key] !== undefined
            ? columnOrderMap[key]
            : Infinity; // keep unmapped ones at the end
      }
    } else if (field.eClass === "FieldGroup" && Array.isArray(field.field)) {
      newField.field = field.field.map((f: any) => attachField(f));

      // Recursively sort FieldGroup contents (if enabled)
      if (preserveProfilingOrder) {
        newField.field.sort(
          (a: any, b: any) => (a._profileOrder ?? Infinity) - (b._profileOrder ?? Infinity)
        );
      }
    }

    return newField;
  }

  // --- Attach profiles and optionally sort at the root level ---
  return dm.map((entity) => {
    const newEntity: any = { ...entity };

    if (Array.isArray(entity.field)) {
      newEntity.field = entity.field.map((f: any) => attachField(f));

      if (preserveProfilingOrder) {
        newEntity.field.sort(
          (a: any, b: any) => (a._profileOrder ?? Infinity) - (b._profileOrder ?? Infinity)
        );
      }
    }

    return newEntity;
  });
};


/*
export const attachProfileToDM = (dm: any[], profiles: any[]): any[] => {
  const profileMap: Record<string, any> = {};
  profiles.forEach((p) => {
    profileMap[p.column_name] = p;
  });

  function attachField(field: any): any {
    const newField: any = { ...field };

    if (field.eClass === "Field") {
      const parts = field.FLD_PHYSICAL_ID?.split("-");
      const key = parts && parts.length > 1 ? parts[1] : null;
      newField.profile = profileMap[key || ""] || field.insight || null;
    } else if (field.eClass === "FieldGroup" && field.field?.length) {
      newField.field = field.field.map((f:any) => attachField(f));
    }

    return newField;
  }

  return dm.map((entity) => {
    const newEntity: any = { ...entity };
    if (entity.eClass === "FieldGroup" && entity.field?.length) {
      newEntity.field = entity.field.map((f:any) => attachField(f));
    }
    return newEntity;
  });
}
*/


export const toTitleCase = (str:string) => {
  if (!str) {
    return "";
  }
  return str.toLowerCase().replace(/\b\w/g, s => s.toUpperCase());
}

export const toTitleCaseLabel = (snakeStr:string) => {
  return snakeStr
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export const hasUniqueValues = (list: any) => {
  const codeSet = new Set();
  const nameSet = new Set();

  for (const item of list) {
    // Check if code or name already exists in the sets
    if (codeSet.has(item.Code) || nameSet.has(item.Name)) {
      return false; // Duplicate found
    }
    // Add code and name to the sets
    codeSet.add(item.Code);
    nameSet.add(item.Name);
  }

  return true; // All values are unique
}

export const getDuplicateValues = (list: any[]) => {
  const codeSet = new Set();
  const nameSet = new Set();
  const duplicateCodes = new Set();
  const duplicateNames = new Set();

  for (const item of list) {
    // Check for duplicates and collect them
    if (codeSet.has(item.Code)) {
      duplicateCodes.add(item.Code);
    } else {
      codeSet.add(item.Code);
    }

    if (nameSet.has(item.Name)) {
      duplicateNames.add(item.Name);
    } else {
      nameSet.add(item.Name);
    }
  }

  return {
    duplicateCodes: Array.from(duplicateCodes),
    duplicateNames: Array.from(duplicateNames)
  };
};

export const removeDuplicates = (list: any[]) => {
  const seenCodes = new Set();
  const seenNames = new Set();
  const uniqueList = [];

  for (const item of list) {
    if (!seenCodes.has(item.Code) && !seenNames.has(item.Name)) {
      seenCodes.add(item.Code);
      seenNames.add(item.Name);
      uniqueList.push(item);
    }
    // Skip if Code or Name already exists
  }

  return uniqueList;
};


type SortOrder = 'asc' | 'desc';

interface SortCriterion<T> {
  key: keyof T;
  order?: SortOrder;
}

export const multiSort = <T>(arr: T[], sortCriteria: SortCriterion<T>[]): T[] => {
  return arr.sort((a, b) => {
    for (let i = 0; i < sortCriteria.length; i++) {
      const { key, order = 'asc' } = sortCriteria[i];
      const aValue = a[key];
      const bValue = b[key];

      // Compare values based on the current key
      if (aValue < bValue) {
        return order === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return order === 'asc' ? 1 : -1;
      }
    }
    return 0;
  });
}

export const isFieldSupposedToBeRemoved = (data: any) =>{
    let removeFld = false;
	let tblRecCnt = data ? data['TABLE_DATA'] : 0;
	let fldCntEmpty = 0;
    if (tblRecCnt ===0){return true;}
	if (data && data['COLUMN_DATA'] && tblRecCnt >0){
		let nullData = data['COLUMN_DATA'].filter((m:any)=>{return !m.DATA}).map((m:any)=> m.CNT);
		fldCntEmpty = nullData.reduce((accumulator:number, currentValue:number) => accumulator + currentValue, 0);

		if (fldCntEmpty > 0 && tblRecCnt > 0 && ( fldCntEmpty / tblRecCnt) > NULL_DENCITY_THRESOLD_PCT){ 
			removeFld = true;
		}
		
		let maxDataDencityPct = data['COLUMN_DATA'].length > 0 ? data['COLUMN_DATA'][0]['CNT']/tblRecCnt : 0;
		if (maxDataDencityPct > MAX_DATA_DENCITY_THRESOLD_PCT){
			removeFld = true;
		}
	}
  
    return removeFld;
  
}

export const isFieldUnused = (data: any) =>{
    let removeFld = false;
	let tblRecCnt = data ? data['tableData'] : 0;
	let fldCntEmpty = 0;
    if (tblRecCnt ===0){return true;}
	if (data && data['columnData'] && tblRecCnt >0){
		let nullData = data['columnData'].filter((m:any)=>{return !m.DATA}).map((m:any)=> m.CNT);
		fldCntEmpty = nullData.reduce((accumulator:number, currentValue:number) => accumulator + currentValue, 0);

		if (fldCntEmpty > 0 && tblRecCnt > 0 && ( fldCntEmpty / tblRecCnt) > NULL_DENCITY_THRESOLD_PCT){ 
			removeFld = true;
		}
		
		let maxDataDencityPct = data['columnData'].length > 0 ? data['columnData'][0]['CNT']/tblRecCnt : 0;
		if (maxDataDencityPct > MAX_DATA_DENCITY_THRESOLD_PCT){
			removeFld = true;
		}
	}
  
    return removeFld;
  
}

export const generateRandomColors = (numColors: number): string[] => {
    const colors = [];
    const step = 360 / numColors; // Divide the hue range evenly
    for (let i = 0; i < numColors; i++) {
      const hue = Math.floor(Math.random() * 360); // Random hue between 0 and 360
      const saturation = 70; // Keep saturation constant for smooth colors
      const lightness = 50; // Keep lightness constant for smoothness
      colors.push(`hsl(${hue}, ${saturation}%, ${lightness}%)`);
    }
    return colors;
}

export const downloadJsonFile = (data:any) => {
    //const data = { name: "Adriva", type: "Accelerator", version: "1.0" }; // Example JSON data
    const jsonString = JSON.stringify(data, null, 2); // Convert JSON to string
    const blob = new Blob([jsonString], { type: "application/json" }); // Create Blob
    const url = URL.createObjectURL(blob); // Create URL

    const link = document.createElement("a"); // Create anchor tag
    link.href = url;
    link.download = "data.json"; // Set filename
    document.body.appendChild(link);
    link.click(); // Trigger download
    document.body.removeChild(link); // Clean up
    URL.revokeObjectURL(url); // Release memory
};


export const generateRandomString = (length = 8) => {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}


export const findField = (data: any, id: string, parent: any = null): any => {
  if (!data || !id) return null; 

  if (data.id === id || data.FLD_ID === id) return { p: parent, c: data }; 

  if (data.field && Array.isArray(data.field)) {
    for (const field of data.field) {
      const result = findField(field, id, data); 
      if (result) return result; 
    }
  }

  return null; 
};


export const updateFieldDeep = (data: any, id: string, newData: any): boolean => {
  if (!data || !id || !newData) return false; // Handle invalid inputs

  if (data.id === id) {
    deepMerge(data, newData); // Perform deep merge
    return true; // Return true when updated
  }

  if (data.field && Array.isArray(data.field)) {
    for (const field of data.field) {
      const updated = updateFieldDeep(field, id, newData);
      if (updated) return true; // Stop recursion once updated
    }
  }

  return false; // If no match found
};

// Deep merge helper function
export const deepMerge = (target: any, source: any) => {
  for (const key of Object.keys(source)) {
    if (
      source[key] &&
      typeof source[key] === "object" &&
      !Array.isArray(source[key])
    ) {
      if (!target[key] || typeof target[key] !== "object") {
        target[key] = {}; // Ensure target has the same structure
      }
      deepMerge(target[key], source[key]); // Recursively merge
    } else {
      target[key] = source[key]; // Assign value directly
    }
  }
};


export const getFieldDataType = (column: any) => {
  let DATA_TYP = '';
  let DATA_LEN = '0';

  const typeName = column.columnType?.['@typeName']?.toUpperCase();
  const length = column.columnType?.['@length'];
  const precision = column.columnType?.['@precision'];
  const scale = column.columnType?.['@scale'];

  // Logic to determine DATA_TYP
  if (column.lookupRDSNm) {
    DATA_TYP = 'LookupField';
  } else if (['VARCHAR', 'CHAR', 'NVARCHAR', 'NVARCHAR2'].includes(typeName)) {
    DATA_TYP = 'TextField';
  } else if (typeName === 'DATE') {
    DATA_TYP = 'DateField';
  } else if (typeName === 'TIMESTAMP') {
    DATA_TYP = 'DateTimeField';
  } else if (typeName === 'INT') {
    DATA_TYP = 'IntegerField';
  } else if (['FLOAT', 'NUMBER'].includes(typeName)) {
    if (scale === '0'){
      DATA_TYP = 'IntegerField';
    }else{
      DATA_TYP = 'DecimalField';
    }
    
  } else {
    DATA_TYP = 'TextField'; // fallback
  }

  // Logic to determine DATA_LEN
  if (['VARCHAR', 'CHAR', 'NVARCHAR', 'NVARCHAR2'].includes(typeName)) {
    DATA_LEN = length || '0';
  } else if (['FLOAT', 'NUMBER'].includes(typeName)) {
    DATA_LEN = `${precision || 0}|${scale || 0}`;
  } else {
    DATA_LEN = '0';
  }

  return { DATA_TYP, DATA_LEN };
}


// Abbreviation dictionary for MDM domains
const abbreviationMap: Record<string, string> = {
  number: "No",
  identifier: "ID",
  id: "ID",
  organization: "Org",
  address: "Addr",
  country: "Ctry",
  telephone: "Tel",
  phone: "Tel",
  category: "Cat",
  description: "Desc",
  information: "Info",
  reference: "Ref",
  status: "Stat",
  customer: "Cstmr",
  product: "Prod",
  location: "Loc",
  vendor: "Vend",
  code: "Cd",
  date: "Dt",
  datetime: "DtTm",
  name: "Nm",
  postal: "Pst",
  region: "Regn",
  area: "Area",
  email: "Email"
};


export const getFieldNmConverted = (input: string|null) => {
  if (!input) return input;
  // Remove special characters and digits, split into words
  const cleaned = input.replace(/[^a-zA-Z0-9\s]/g, " ");
  const words = cleaned.trim().split(/\s+/);

  // Convert each word using abbreviation if available
  const pascalWords = words.map(word => {
    const lower = word.toLowerCase();
    const abbr = abbreviationMap[lower];
    const finalWord = abbr || word;
    return finalWord.charAt(0).toUpperCase() + finalWord.slice(1);
  });

  return pascalWords.join("");
}

export const getFieldGrpNmConverted =(input: string|null) => {
  if (!input) return input;
  // Remove special characters and digits, split into words
  const cleaned = input.replace(/[^a-zA-Z\s]/g, " ");
  const words = cleaned.trim().split(/\s+/);

  // Convert each word using abbreviation if available
  const pascalWords = words.map(word => {
    const finalWord = word;
    return finalWord.charAt(0).toUpperCase() + finalWord.slice(1);
  });

  return pascalWords.join("");
}


export const mergeDMJSON = (targetJson: any, sourceJson: any): any => {
  function mergeFields(targetFields: any[], sourceFields: any[]): any[] {
    const sourceMap = new Map(sourceFields.map(field => [field.FLD_PHYSICAL_ID, field]));
    const targetMap = new Map(targetFields.map(field => [field.FLD_PHYSICAL_ID, field]));

    sourceFields.forEach(sourceField => {
      if (sourceField.FLD_PHYSICAL_ID && sourceField.FLD_PHYSICAL_ID !== "") {
        if (!targetMap.has(sourceField.FLD_PHYSICAL_ID)) {
          targetFields.push(sourceField);
          targetMap.set(sourceField.FLD_PHYSICAL_ID, sourceField);
        }
      }
    });

    const mergedTarget = targetFields.filter(targetField => {
      return sourceMap.has(targetField.FLD_PHYSICAL_ID) || targetField.FLD_PHYSICAL_ID === "" || !targetField.FLD_PHYSICAL_ID;
    });

    return mergedTarget;
  }

  function mergeGroupContent(targetGroup: any, sourceGroup: any) {
    if (targetGroup.field && sourceGroup.field) {
      const targetFields = targetGroup.field.filter((f:any) => f.eClass !== "FieldGroup");
      const sourceFields = sourceGroup.field.filter((f:any) => f.eClass !== "FieldGroup");
      const targetSubGroups = targetGroup.field.filter((f:any) => f.eClass === "FieldGroup");
      const sourceSubGroups = sourceGroup.field.filter((f:any) => f.eClass === "FieldGroup");
      
      targetGroup.field = [
        ...mergeFields(targetFields, sourceFields),
        ...mergeFieldGroups(targetSubGroups, sourceSubGroups)
      ];
      
      targetGroup.matchFieldList = [];
      sourceGroup.matchFieldList && sourceGroup.matchFieldList.forEach((fld:any) =>{
        if (targetGroup.field.filter((f:any) => f.eClass !== "FieldGroup" && (f.FLD_ID === fld || f.FLD_PHYSICAL_ID === fld)).length > 0){
          targetGroup.matchFieldList.push(fld);
        }
      });
      
      targetGroup.matchFieldURIsExactOrNull = [];
      sourceGroup.matchFieldURIsExactOrNull && sourceGroup.matchFieldURIsExactOrNull.forEach((fld:any) =>{
        if (targetGroup.field.filter((f:any) => f.eClass !== "FieldGroup" && (f.FLD_ID === fld || f.FLD_PHYSICAL_ID === fld)).length > 0){
          targetGroup.matchFieldURIsExactOrNull.push(fld);
        }
      });
      
      targetGroup.matchFieldListExactOrAllNull = [];
      sourceGroup.matchFieldListExactOrAllNull && sourceGroup.matchFieldListExactOrAllNull.forEach((fld:any) =>{
        if (targetGroup.field.filter((f:any) => f.eClass !== "FieldGroup" && (f.FLD_ID === fld || f.FLD_PHYSICAL_ID === fld)).length > 0){
          targetGroup.matchFieldListExactOrAllNull.push(fld);
        }
      });
      
      
    }
  }

  function mergeFieldGroups(targetGroups: any[], sourceGroups: any[]): any[] {
    const sourceGroupMap = new Map(sourceGroups.map(group => [group.id, group]));
    const targetGroupMap = new Map(targetGroups.map(group => [group.id, group]));

    sourceGroups.forEach(sourceGroup => {
      if (sourceGroup.id && sourceGroup.id !== "" && !sourceGroup.id.startsWith("CFG_")) {
        if (!targetGroupMap.has(sourceGroup.id)) {
          targetGroups.push(sourceGroup);
          targetGroupMap.set(sourceGroup.id, sourceGroup);
        } else {
          mergeGroupContent(targetGroupMap.get(sourceGroup.id), sourceGroup);
        }
      } else if (sourceGroup.id && sourceGroup.id.startsWith("CFG_")) {
        if (!targetGroupMap.has(sourceGroup.id)) {
          targetGroups.push(sourceGroup);
          targetGroupMap.set(sourceGroup.id, sourceGroup);
        }
      }
    });

    const mergedTarget = targetGroups.filter(targetGroup => {
      return sourceGroupMap.has(targetGroup.id) || targetGroup.id.startsWith("CFG_") || !targetGroup.id;
    });

    return mergedTarget;
  }

  if (targetJson.field && sourceJson.field) {
    const targetFields = targetJson.field.filter((f:any) => f.eClass !== "FieldGroup");
    const sourceFields = sourceJson.field.filter((f:any) => f.eClass !== "FieldGroup");
    const targetGroups = targetJson.field.filter((f:any) => f.eClass === "FieldGroup");
    const sourceGroups = sourceJson.field.filter((f:any) => f.eClass === "FieldGroup");

    targetJson.field = [
      ...mergeFields(targetFields, sourceFields),
      ...mergeFieldGroups(targetGroups, sourceGroups)
    ];
  }

  return targetJson;
}


export const extractSrcSystems = (data: any, srcSys: any[] = []): any[] => {
  data.field?.filter((field: any) => field.eClass === 'Field').forEach((field: any) => {
    if (field.SYSTEM_ORDER) {
      field.SYSTEM_ORDER.split(';').forEach((s: string) => {
        const parts = s.split('|');
        const code = parts[0];
        if (parts.length === 2 && !srcSys.find((sys: any) => sys.code === code)) {
          const maxId = srcSys.length > 0 ? Math.max(...srcSys.map((sys: any) => parseInt(sys.id))) : 0;
          srcSys.push({
            code,
            name: parts.length > 1 ? parts[1] : '',
            id: (maxId + 1).toString(),
          });
        }
      });
    }
  });

  data.field?.filter((field: any) => field.eClass === 'FieldGroup').forEach((fieldGroup: any) => {
    extractSrcSystems(fieldGroup, srcSys);
  });

  return srcSys;
};

export const replaceSrcSystemsCodeNmWithId = (data: any, srcSystems: any[]) => {
  data.field?.filter((field: any) => field.eClass === 'Field').forEach((field: any) => {
    if (field.SYSTEM_ORDER) {
      const srcSystemIds: string[] = [];
      field.SYSTEM_ORDER.split(';').forEach((s: string) => {
        const parts = s.split('|');
        if (parts.length > 1) {
          const code = parts[0];
          const sys = srcSystems.find((system: any) => system.code === code);
          if (sys) {
            srcSystemIds.push(sys.id);
          }
        } else {
          const sys = srcSystems.find((system: any) => system.id === s);
          if (sys) {
            srcSystemIds.push(s);
          }
        }
      });
      field.SYSTEM_ORDER = srcSystemIds.join(';');
    }
  });

  data.field?.filter((field: any) => field.eClass === 'FieldGroup').forEach((fieldGroup: any) => {
    replaceSrcSystemsCodeNmWithId(fieldGroup, srcSystems);
  });
};

export const cleanDm = (refinedDm: any[], srcSys: any[]) => {
  refinedDm.forEach((fields: any) => {
    extractSrcSystems(fields, srcSys);
    replaceSrcSystemsCodeNmWithId(fields, srcSys);
  });
};

export const transformFieldGroup = (fieldGroup: any, parentTableName: string | null = null): any[] => {
  const result: any[] = [];
  const tableName = fieldGroup?.name;
  const tableDisplayName = fieldGroup?.label;

  for (const field of fieldGroup?.field || []) {
    if (field?.eClass === "Field") {
      result.push(field);
    } else if (field?.eClass === "FieldGroup") {
      result.push(...transformFieldGroup(field, tableName));
    }
  }

  return result;
}

export const convertToRawDm = (inputJson: any): any => {
  const outputJson: any = {};

  if (typeof inputJson === "object" && !Array.isArray(inputJson)) {
    console.log("inputJson is a dictionary");

    const keys = Object.keys(inputJson);
    for (const key of keys) {
      const fields = inputJson[key];
      outputJson[key] = transformFieldGroup(fields);
    }

  } else if (Array.isArray(inputJson)) {
    console.log("inputJson is a list");

    for (const e of inputJson) {
      const key = e["id"];
      outputJson[key] = transformFieldGroup(e);
    }
  }

  return outputJson;
}





